<div class="m-1">
    <mat-icon
        *ngIf="status === 'online'"
        [matTooltip]="'common.online' | translate"
        matTooltipPosition="above"
        style="color: #4CAF50"
    >check_circle_outline
    </mat-icon>
    <mat-icon
        *ngIf="status === 'offline'"
        [matTooltip]="'common.offline' | translate"
        matTooltipPosition="above"
        style="color: #CF5555"
    >highlight_off
    </mat-icon>
    <mat-icon
        *ngIf="status === 'warning'"
        [matTooltip]="'common.warning' | translate"
        matTooltipPosition="above"
        style="color: #f1d259"
    >highlight_off
    </mat-icon>
    <mat-icon
        *ngIf="status === 'no_data'"
        [matTooltip]="'common.no_data' | translate"
        matTooltipPosition="above"
        style="color: gray"
    >highlight_off
    </mat-icon>
</div>
